<template>
  <div class="forward-tracking" style="width:100%;heigh:100%;">
    <div class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="">
            <span class="title">订单号：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              :remote-method="orderRemoteMethod"
              remote="remote"
              :loading="loading"
              @change="orderSelectChange($event)"
              @clear="orderRemoteMethod"
              v-model="searchForm.orderId"
              clearable
              placeholder="订单号"
              filterable
            >
              <el-option v-for="(item, index) in orderOptions" :key="index + Math.random()" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">物料编码：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="materialRemoteMethod"
              remote
              :remote-method="query => this.materialRemoteMethod('', query)"
              :loading="loading"
              @change="materilSelectChange($event)"
              v-model="searchForm.materialId"
              clearable
              placeholder="物料编码"
              filterable
            >
              <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialCode" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">物料名称：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="materialRemoteMethod"
              remote
              :remote-method="query => this.materialRemoteMethod(query)"
              :loading="loading"
              @change="materilSelectChange($event)"
              v-model="searchForm.materialId"
              clearable
              placeholder="物料名称"
              filterable
            >
              <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialName" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span="5">
          <div class="">
            <span class="title">批次号：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              remote
              @clear="batchRemoteMethod"
              :remote-method="batchRemoteMethod"
              :loading="loading"
              @change="splitSelectChange($event)"
              v-model="searchForm.splitId"
              clearable
              placeholder="批次号"
              filterable
            >
              <el-option v-for="(item, index) in splitList" :key="index + Math.random()" :label="item.productionBatchCode" :value="item.splitId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div style="text-align:right">
            <el-button size="mini" :disabled="!searchForm.splitId" icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20">
                <el-col :span="5">
                    <div class="" >
                        <span class="title">规格：</span>
                        <el-select size="small" style="max-width:180px;"  v-model="searchForm.splitId"  clearable placeholder="规格" filterable>
                            <el-option v-for="item in splitList" :key="item.splitId" :label="item.specification"   :value="item.splitId"></el-option>
                        </el-select>
                    </div>
                </el-col>
               
                <el-col :span="19">
                    <div style="text-align:right">
                        <el-button size="mini" :disabled='!searchForm.splitId' icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row> -->
    </div>

    <el-row :gutter="10">
      <el-col :span="4" class="left-border">
        <span class="bom-title">物料bom结构</span>
        <el-tree
          ref="tree"
          :default-expand-all="true"
          node-key="id"
          class="tree-list"
          :default-expanded-keys="[selecTree]"
          :current-node-key="selecTree"
          accordion
          :data="materialTree"
          :highlight-current="true"
          :expand-on-click-node="false"
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </el-col>

      <el-col :span="20">
        <el-tabs type="border-card" class="eltabs" v-model="activeName" @tab-click="itemChange">
          <el-tab-pane label="批次物料" name="batchMaterialDtos">
            <el-table :data="batchMaterialDtos" :maxHeight="600">
              <el-table-column prop="materialCode" label="物料编码"></el-table-column>
              <el-table-column prop="materialName" label="物料名称"></el-table-column>
              <el-table-column prop="specification" label="规格"></el-table-column>
              <el-table-column prop="batchCode" label="批次号"></el-table-column>
              <el-table-column prop="productionStartTime" label="生产开始时间"></el-table-column>
              <el-table-column prop="productionEndTime" label="生产结束时间"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="原材料信息" name="rawMaterialDtos">
            <el-table :data="rawMaterialDtos" :maxHeight="600">
              <el-table-column prop="materialCode" label="物料编码"></el-table-column>
              <el-table-column prop="materialName" label="物料名称"></el-table-column>
              <el-table-column prop="specification" label="规格"></el-table-column>
              <el-table-column prop="supplier" label="供应商"></el-table-column>
              <el-table-column prop="batchCode" label="批次"></el-table-column>
              <el-table-column prop="amount" label="数量"></el-table-column>
              <el-table-column prop="inspectionStatus" label="来料检验结果" :formatter="parseInspectionStatus"></el-table-column>
              <el-table-column prop="stockInTime" label="入库时间"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="生产过程" name="productiveProcessDtos">
            <el-table :data="productiveProcessDtos" :maxHeight="600">
              <el-table-column prop="procedureName" label="工序名称"></el-table-column>
              <el-table-column prop="workerName" label="执行人"></el-table-column>
              <el-table-column prop="deviceName" label="加工设备"></el-table-column>
              <el-table-column prop="finishedAmount" label="完成数量"></el-table-column>
              <el-table-column prop="startTime" label="开始时间"></el-table-column>
              <el-table-column prop="endTime" label="结束时间"></el-table-column>
              <el-table-column prop="hours" label="实际加工工时"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="检验信息" name="qcTaskDtos">
            <el-table :data="qcTaskDtos" :maxHeight="600">
              <el-table-column prop="qcTaskCode" label="检验单号"></el-table-column>
              <el-table-column prop="procedureName" label="工序名称"></el-table-column>
              <el-table-column prop="inspectCount" label="质检数量"></el-table-column>
              <el-table-column prop="unQualifiedCount" label="不合格数量"></el-table-column>
              <!-- <el-table-column prop="scrapCount" label="报废数量"></el-table-column> -->
              <el-table-column prop="qualificationRate" label="合格率"></el-table-column>
              <el-table-column prop="qualityInspector" label="质检人"></el-table-column>
              <el-table-column prop="inspectType" :formatter="parseQcType" label="质检类型"></el-table-column>
              <el-table-column prop="checkDate" label="质检时间"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CommonUtils from "../../util/CommonUtils";
export default {
  name: "ForwardTracking",
  data() {
    return {
      resultOption: [
        { label: "合格", value: 0 },
        { label: "不合格退回", value: 1 },
        { label: "特采", value: 2 }
      ],
      defaultProps: {
        children: "son",
        label: "materialName"
      },
      materialTree: [],
      isNodeClick: false,
      splitId: null,
      map: {
        batchMaterialDtos: 1,
        rawMaterialDtos: 2,
        productiveProcessDtos: 3,
        qcTaskDtos: 4
      },
      tracesType: 1,
      splitList: [],
      loading: false,
      orderOptions: [],
      materialList: [],
      selecTree: 1,
      batchMaterialDtos: [],
      rawMaterialDtos: [],
      productiveProcessDtos: [],
      qcTaskDtos: [],
      activeName: "batchMaterialDtos",
      fristLoad: false,
      W: false,
      searchForm: {
        splitId: null,
        orderId: null,
        materialId: null
      },
      splitIds: [],
      typeOption: [
        { label: "母卷质量检", value: 1 },
        { label: "自检", value: 4 },
        { label: "子卷质量检", value: 3 },
        { label: "终检", value: 2 },
        { label: "其它", value: 5 }
      ],
      data: {
        token: localStorage.getItem("token")
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  components: {},
  mounted: async function() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    this.splitList = await this.loadSplitList();
    this.orderRemoteMethod();
    this.materialList = await this.loadMaterialList();
  },

  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },

  methods: {
    async loadMaterialList(materialName, materialCode, orderId) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listMaterialBySplit", type: "sync", params: { materialName, materialCode, orderId } });
      return data;
    },

    async loadSplitList(orderId, productionBatchCode, materialId) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listSplitProductionBatchCode", type: "sync", params: { orderId, productionBatchCode, materialId } });
      return data;
    },

    async orderRemoteMethod(query) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listOrder", params: { orderCode: query } });
      this.orderOptions = data.filter(item => item.label);
      this.loading = false;
    },

    async materialRemoteMethod(materialName, materialCode, orderId) {
      this.loading = true;
      this.materialList = await this.loadMaterialList(materialName, materialCode, this.searchForm.orderId);
      this.loading = false;
    },

    async batchRemoteMethod(query) {
      this.loading = true;
      this.splitList = await this.loadSplitList(this.searchForm.orderId, query);
      this.loading = false;
    },

    async orderSelectChange(ev) {
      this.$set(this.searchForm, "splitId", null);
      this.splitList = await this.loadSplitList(ev);
      if (!this.searchForm.materialId) {
        this.materialList = await this.loadMaterialList("", "", ev);
      }
    },

    async splitSelectChange(ev) {
      if (ev) {
        let find = this.splitList.find(item => item.splitId == ev) || {};
        log(find, 55555);
        this.orderOptions = this.splitList
          .map(item => {
            return { id: item.orderId, label: item.orderCode, value: item.orderId };
          })
          .filter(item => item.label);

        this.materialList = CommonUtils.cloneObj([find]);

        this.$set(this.searchForm, "orderId", find.orderId);
        // this.$set(this.searchForm,'materialId',find.materialId)
        this.searchForm.materialId = find.materialId;
        log(this.materialList, this.searchForm.materialId, this.materialList[0].materialId == this.searchForm.materialId, 6666);
      }
    },

    async materilSelectChange(ev) {
      this.splitList = await this.loadSplitList(this.searchForm.orderId, "", ev);

      if (this.searchForm.splitId) {
        let find = this.splitList.find(item => item.splitId == this.searchForm.splitId);
        if (!find) {
          this.$set(this.searchForm, "splitId", null);
        }
      }
      if (!this.searchForm.orderId) {
        if (ev) {
          this.orderOptions = this.splitList
            .map(item => {
              return { id: item.orderId, label: item.orderCode, value: item.orderId };
            })
            .filter(item => item.label);
        } else {
          await this.orderRemoteMethod();
        }
      } else {
      }
    },

    async handleNodeClick({ materialId, splitIds }) {
      this.isNodeClick = true;
      this.splitIds = splitIds;

      this.search(splitIds);
    },

    itemChange() {
      this.tracesType = this.map[this.activeName];
      if (this.isNodeClick) {
        this.search(this.splitIds);
      } else {
        this.search(this.searchForm.splitId);
      }
    },

    btnSearch() {
      this.isNodeClick = false;
      this.search(this.searchForm.splitId);
    },

    clearSearch() {
      this.searchForm.splitId = null;
      this.searchForm.orderId = null;
      this.searchForm.materialId = null;
    },

    search: function(splitIds) {
      let tracesType = [1];
      if (this.tracesType != 1) {
        tracesType = [1, this.tracesType];
      }
      let params = {
        tracesType
      };
      if (!this.isNodeClick) {
        params.splitId = splitIds;
      } else {
        params.splitIds = splitIds;
      }
      this.$RequestUtil.post({
        url: "/api/productionTraceability/forwardTracing",
        type: "sync",
        params,
        success: res => {
          if (res.code == 0) {
            if (!this.isNodeClick) {
              this.materialTree = res.data.billOfMaterialsDtos;
            }
            this.batchMaterialDtos = res.data.batchMaterialDtos;
            this.rawMaterialDtos = res.data.rawMaterialDtos;
            this.productiveProcessDtos = res.data.productiveProcessDtos;
            this.qcTaskDtos = res.data.qcTaskDtos;
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    parseInspectionStatus(rowData) {
      if (rowData.inspectionResult === null) {
        return "";
      }
      let num = Number(rowData.inspectionResult);
      return (this.resultOption.find(item => item.value == num) || {}).label;
    },

    parseQcType(rowData) {
      let num = Number(rowData.inspectType);
      let str = "";
      this.typeOption.forEach(item => {
        if (item.value == num) {
          str = item.label;
        }
      });
      return str;
    }
  }
};
</script>

<style scoped>
.tree-list {
  /* width: 380px; */
}

.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}

.left-border {
  height: 666px;
  border: 1px solid #b4bccc;
  border-radius: 4px;
}
.bom-title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  margin-left: -4px;
  line-height: 34px;
  line-height: 34px;
  font-weight: 600;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}

.import_upload {
  display: inline;
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 14px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.forward-tracking .el-tree > .el-tree-node {
  margin-bottom: 30px;
}
.forward-tracking .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
}
.forward-tracking .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #409eff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/productTracking/ForwardTracking.vue